<template>
  <div class="event-card-container" :class="isNoTrans ? 'noTransition' : null">
    <div class="part-one">
      <div class="part-one-detail">
        <div class="approve-icon part-one-icon"></div>
        <div class="part-one-event-name">
          <div class="part-one-pref-date">{{ event.prefDate }}</div>
          <div class="part-one-event-name-text">{{ event.eventName }}</div>
        </div>
        <div class="wrapper-menu">
          <div v-if="isLive" v-b-tooltip.hover.bottom :title="'This event is live'" class="wrapper-status-icon">
          </div>
          <div class="wrapper-more-icon" v-b-tooltip.hover.bottom :title="'More'" @click="openMenu()">
          </div>
        </div>
      </div>
      <click-outside :handler="closeMenu">
        <div v-if="isOpenMenu" class="wrapper-list">
          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center" @click="openModal()">
              <div class="icon-information-black"></div>
              <div>Event details</div>
            </b-list-group-item>

            <b-list-group-item @click="updateIsLiveEvent('LIVE')" class="d-flex justify-content-between align-items-center">
              <div class="status-icon-black" ></div>
              <div>Make event {{isLive ? 'un-live': 'live'}}</div>
            </b-list-group-item>
          </b-list-group>
        </div>
      </click-outside>
    </div>
    <div class="part-two">
      <div v-if="event.trackingStatus !== 'Shipping info not entered'" :class="{'partTwoDetail' : isAdminOrEMView}">
        <div class="oval oval-green"></div> <!--ovalOrange-->
        <div class="supplies-status">{{event.trackingStatus}}</div>
      </div>
      <div v-if="event.trackingStatus === 'Shipping info not entered'" :class="{'partTwoDetail' : isAdminOrEMView}">
        <div class="oval oval-red"></div>
        <div class="supplies-status">{{event.trackingStatus}}</div>
      </div>
      <div v-if="isAdminOrEMView" class="part-two-detail">
        <div class="oval oval-green"></div>
        <div class="supplies-status">Staffed for {{event.numStaffScreener + event.numStaffLead + event.numStaffConcierge}}/{{event.maxStaffScreener + event.maxStaffLead + event.maxStaffConcierge}}</div>
      </div>
      <div v-if="isAdminOrEMView">
        <div v-if="event.emailReminderStatus === emailTemplateConsts.notReminded" class="oval oval-red"></div>
        <div v-if="event.emailReminderStatus !== emailTemplateConsts.notReminded && event.emailReminderStatus !== emailTemplateConsts.thankyou" class="oval oval-orange"></div>
        <div v-if="event.emailReminderStatus === emailTemplateConsts.thankyou" class="oval oval-green"></div>
        <div class="supplies-status">Last Email Sent: {{event.emailReminderStatus | templateName}}</div>
      </div>
      <div v-if="isAdminOrEMView">
        <div v-if="event.maxParticipant === 0 || event.numParticipant < event.maxParticipant/2" class="oval oval-red"></div>
        <div v-if="event.maxParticipant > 0 && event.numParticipant >= event.maxParticipant/2 && event.numParticipant < event.maxParticipant" class="oval oval-orange"></div>
        <div v-if="event.maxParticipant > 0 && event.numParticipant >= event.maxParticipant" class="oval oval-green"></div>
        <div class="supplies-status">Participants Signups: {{event.numParticipant}}/{{event.maxParticipant}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import consts from '../../../_consts';
  import emailTemplateConsts from '@/store/constants/emailTemplateType';
  import {mapActions, mapGetters} from 'vuex';
  import ClickOutside from 'onclick-outside';
  export default {
    name: 'manage-view',
    components: {
      ClickOutside
    },
    props: {
      event: {
        type: Object,
        default: {}
      },
      isNoTrans: {
        type: Boolean,
        default: false
      },
      isChangeOrder: {
        type: Boolean,
        default: false
      },
      isFromClientDashboardView: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        emailTemplateConsts: emailTemplateConsts,
        isAdminOrEMView: false,
        isOpenMenu: false,
        isLive: false
      }
    },
    created () {
      let isView = localStorage.getItem(consts.LOCAL_STORE.role);
      this.isAdminOrEMView = (isView === consts.USER_ROLE.admin) || (isView === consts.USER_ROLE.eventManager);
    },
    methods: {
      openModal () {
        localStorage.setItem('isFromClientDashboardView', this.isFromClientDashboardView);
        localStorage.setItem('isFromStaff', false);
        let params = {
          eventId: this.event.id,
          isChangeOrder: this.isChangeOrder,
          onChangeEvent: this.onChangeEvent
        };
        this.$modal.show('eventDetailModal', params);
      },
      openMenu () {
        if (!this.isOpenMenu) {
          this.isOpenMenu = true;
        } else {
          this.isOpenMenu = false;
        }
      },
      closeMenu () {
        this.isOpenMenu = false;
      },
      updateIsLiveEvent (type) {
        let isCheck;
        switch (type) {
          case 'LIVE':
            isCheck = !this.isLive;
            break;
          case 'ONLINE_SCHEDULER':
            isCheck = this.event.isOnlineScheduler;
            break;
          default:
            isCheck = false;
        }
        this.actionUpdateIsLiveEvent({
          eventId: this.event.id,
          isCheck: isCheck || false,
          onlineType: type
        }).then((response) => {
          if (response.message) {
            this.$toastr('error', response.message, '');
          } else {
            this.isLive = response.event.isLive;
            this.$toastr('success', 'Update event successful!', '');
          }
        });
      },
      onChangeEvent (event) {
        this.event.maxStaffLead = event.maxStaffLead;
        this.event.maxStaffConcierge = event.maxStaffConcierge;
        this.event.maxStaffScreener = event.maxStaffScreener;
      },
      ...mapActions({
        getEventById: 'ACTION_GET_EVENT_BY_ID',
        actionUpdateIsLiveEvent: 'ACTION_UPDATE_IS_LIVE_EVENT'
      })
    },
    computed: {
      ...mapGetters({
        getLoading: 'GETTERS_IS_LOADING'
      })
    },
    mounted () {
      this.isLive = this.event.isLive;
    }
  }
</script>
<style lang="less" scoped>
  @import '~@/styles/variables.less';
  .event-card-container {
    width: 291px;
    border-radius: 4px;
    background-color: @white;
    -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);
    position: relative;
    top: 0;
    transition: top .25s;
    transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
    &:hover {
      cursor: pointer;
      top: -10px;
      .part-one{
        .part-one-detail{
          .part-one-event-name{
            max-width: calc(~'100% - 36px');
          }
        }
        .approve-icon{
          width: 28px;
          height: 28px;
          transform: scale(1.2);
          transition: transform .25s;
        }
      }

      &.noTransition:hover {
        -moz-transition: none;
        -webkit-transition: none;
        -o-transition: none;
        transition: none;
      }
    }
    .part-one {
      // height: 79px;
      width: 291px;
      position: relative;
    }
    .part-two {
      width: 291px;
      border-radius: 0 0 4px 4px;
      background-color: #F5F5F5;
      border-top: 1px solid #E6E6E6;
      padding-top: 7px;
      padding-bottom: 8px;
    }
    .part-two-detail {
      padding-bottom: 1px;
    }
    .approve-icon {
      height: 25px;
      width: 25px;
      background-color: #606060;
      -webkit-mask: url('../../../../static/img/event-approved.svg') no-repeat center;
      mask: url('../../../../static/img/event-approved.svg') no-repeat center;
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        background: url('../../../../static/img/event-approved-grey.svg') no-repeat center;
      }
      @supports (-ms-ime-align: auto) {
        /* Microsoft EdgeV13&14 CSS styles go here */
        background: url('../../../../static/img/event-approved-grey.svg') no-repeat center;
      }
    }

    .wrapper-menu {
      position: absolute;
      right: 16px;
      top: 16px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      width: 50px;
      height: 24px;

      .wrapper-more-icon {
        height: 24px;
        width: 24px;
        background-color: #2FBEFF;
        transform: rotate(90deg);
        -webkit-mask: url('../../../../static/img/more.svg') no-repeat center;
        mask: url('../../../../static/img/more.svg') no-repeat center;
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          background: url('../../../../static/img/more-blue.svg') no-repeat center;
        }
        @supports (-ms-ime-align: auto) {
          /* Microsoft EdgeV13&14 CSS styles go here */
          background: url('../../../../static/img/more-blue.svg') no-repeat center;
        }
      }


      .wrapper-status-icon {
        width: 24px;
        height: 24px;
        background-color: #2FBEFF;
        -webkit-mask: url('../../../../static/img/live.svg') no-repeat center;
        mask: url('../../../../static/img/live.svg') no-repeat center;
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          background: url('../../../../static/img/live.svg') no-repeat center;
        }
        @supports (-ms-ime-align: auto) {
          /* Microsoft EdgeV13&14 CSS styles go here */
          background: url('../../../../static/img/live.svg') no-repeat center;
        }
      }
    }
    .wrapper-list {
      position: absolute;
      height: 200px;
      left: 100%;
      top: 16px;
      z-index: 999;
      cursor: pointer;
      width: 230px;
    }

    // For black icon
    .status-icon-black {
      height: 27px;
      width: 27px;
      margin-right: 10px;
      background-color: @black;
      -webkit-mask: url('../../../../static/img/live.svg') no-repeat center;
      mask: url('../../../../static/img/live.svg') no-repeat center;
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        background: url('../../../../static/img/live.svg') no-repeat center;
      }
      @supports (-ms-ime-align: auto) {
        /* Microsoft EdgeV13&14 CSS styles go here */
        background: url('../../../../static/img/live.svg') no-repeat center;
      }
    }
    .icon-settings{
      width: 27px;
      height: 27px;
      margin-right: 10px;
      color: @black;
      background-color: @black;
      -webkit-mask: url('../../../../static/img/gear.svg') no-repeat center;
      mask: url('../../../../static/img/gear.svg') no-repeat center;
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        background: url('../../../../static/img/gear.svg') no-repeat center;
      }
      @supports (-ms-ime-align: auto) {
        background: url('../../../../static/img/gear.svg') no-repeat center;
      }
    }

    .icon-information-black {
      width: 27px;
      height: 27px;
      margin-right: 10px;
      background-color: @black;
      -webkit-mask: url('../../../../static/img/status-information.svg') no-repeat center;
      mask: url('../../../../static/img/status-information.svg') no-repeat center;
      @supports (-ms-ime-align: auto) {
        background: url('../../../../static/img/status-information.svg');
      }
    }

    .justify-content-between {
      justify-content: left !important;
    }

    .part-one-detail {
      width: 100%;
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 16px;
    }
    .part-one-icon {
      width: 24px;
    }
    .part-one-event-name {
      margin-left: 8px;
      max-width: calc(~'100% - 32px');
    }
    .part-one-event-name-text {
      font-size: 16px;
      color: black;
    }
    .part-one-number {
      width: 49px;
      display: inline-block;
      position: relative;
      top: -5px;
    }
    .part-one-pref-date {
      font-size: 16px;
      color: black;
      font-weight: 600;
    }
    .mask-green {
      height: 24px;
      width: 49px;
      border: 1px solid #5EA913;
      border-radius: 12px;
    }
    .mask-red {
      height: 24px;
      width: 49px;
      border: 1px solid #E93000;
      border-radius: 12px;
    }
    .mask-orange {
      height: 24px;
      width: 56px;
      border: 1px solid #E99819;
      border-radius: 12px;
    }
    .number {
      height: 16px;
      /* width: 50%; */
      color: #5EA913;
      font-family: "Open Sans", serif;
      font-size: 12px;
      letter-spacing: 0.1px;
      line-height: 16px;
      /* margin-left: 8px; */
      display: table;
      padding-top: 3px;
      /* margin-top: 10px; */
      margin: auto;
    }
    .supplies-status {
      height: 16px;
      color: #424242;
      font-family: "Open Sans", serif;
      font-size: 12px;
      line-height: 16px;
      display: inline-block;
      text-transform: lowercase;
    }
    .supplies-status:first-letter {
      text-transform: uppercase;

    }
    .oval {
      height: 8px;
      width: 8px;
      display: inline-block;
      border-radius: 3px;
      margin-left: 16px;
      margin-right: 3px;
      &.oval-red {
        background-color: #E93000;
      }
      &.oval-green {
        background-color: #68B814;
      }
      &.oval-orange {
        background-color: #FFA71B;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// EventCard.vue?5d23123e